"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiConsumer = void 0;
/**
 * Consumer for apis exposed with {@see ApiExposer}.
 *
 * A strategy that matches the strategy used to expose a target API must be provided.
 */
class ApiConsumer {
    // eslint-disable-next-line
    constructor(strategy) {
        this.strategy = strategy;
        /**
         * Consumes an api exposed using a given transport strategy, and generates a client
         * for easy, type safe consumption of that client.
         * @param options Strategy specific consumption options.
         * @returns An api client matching the given type.
         */
        this.consume = async (options) => {
            const exposedProperties = await this.strategy.getExposedFunctions(options);
            return exposedProperties.reduce((client, prop) => ({
                ...client,
                [prop.key]: this.strategy.createFunction(prop, options)
            }), {});
        };
    }
}
exports.ApiConsumer = ApiConsumer;
